module.exports = __webpack_public_path__ + "static/img/design.48d54859.png";